// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".associate-cluster-associate-cluster-c5787{margin:16px;padding:16px 16px 0}.associate-cluster-associate-cluster-c5787 .icloud-ui-card-title{display:none}.associate-cluster-page-footer-d8e74{position:-webkit-sticky;position:sticky}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"associate-cluster": "associate-cluster-associate-cluster-c5787",
	"associateCluster": "associate-cluster-associate-cluster-c5787",
	"page-footer": "associate-cluster-page-footer-d8e74",
	"pageFooter": "associate-cluster-page-footer-d8e74"
};
export default ___CSS_LOADER_EXPORT___;
